import VueI18n from 'vue-i18n';
import Vue from 'vue';
import enLocale from 'element-ui/lib/locale/lang/en'; // 引入Element UI的英文包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'; // 引入Element UI的中文包

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'zh', // 语言标识
  messages: {
    zh: Object.assign(require('./zh'), zhLocale), // 中文语言包
    en: Object.assign(require('./en'), enLocale), // 英文语言包
    zhTW: Object.assign(require('./zh-TW'), enLocale), // 英文语言包
  },
  fallbackLocale: 'zh',
});

// 获取某一语言包里面的某一内容
const getItem = (type) => {
  return i18n.messages[i18n.locale][type];
};

export { i18n, getItem };

